import type { TutorialDemoNote, TutorialDemoNoteRun } from '@/features/session-tutorial/sessionTutorial.types';
import { useRef } from 'react';

/** For a session page: whether its sample is on the page, and whether the note shown was made from it. */
export const useTutorialDemoNote = (): TutorialDemoNote => {
  const isSampleShownRef = useRef(false);
  const isNoteFromSampleRef = useRef(false);

  return {
    markSampleShown: () => {
      isSampleShownRef.current = true;
    },
    startNote: (): TutorialDemoNoteRun => {
      const fromSample = isSampleShownRef.current;
      return {
        // The tour ended while this sample note was being written: never show it.
        isStale: () => fromSample && !isSampleShownRef.current,
        markShown: () => {
          isNoteFromSampleRef.current = fromSample;
        },
      };
    },
    clearSample: () => {
      isSampleShownRef.current = false;
      const hadSampleNote = isNoteFromSampleRef.current;
      isNoteFromSampleRef.current = false;
      return hadSampleNote;
    },
  };
};
